export default function ({ app, $axios, $config, isDev }) {
    // we don't want to run this if we are in development mode
    if (isDev) return

    let isAppValid = true

    // Create and interval that will run every 15 minutes, checks if the app is valid or not by setting a isAppValid variable by comparing Epochs'
    const intervalInMinutes = 15

    setInterval(async () => {
        try {
            const { data } = await $axios.get($config.platform.apis.version)

            // If the time that the app was built is higher than the newest "breaking" version, then the app is still valid
            isAppValid = process.env.BUILD_TIME > data.version
        } catch (error) {
            app.$log.error('Unable to get app version', error)
        }
    }, 1000 * 60 * intervalInMinutes)

    // Checks the status of the isAppValid flag and if the app needs to be reloaded then set the location to whatever arg is passed
    function reloadApp(routePath) {
        // If the app is still valid then we don't want to reload the app
        if (isAppValid) return

        // If we make it here, then the app isn't valid. so we set the location to the pass url
        window.location = routePath
    }

    app.router.beforeEach((to, from, next) => {
        // When the TO path and the FROM path are not equal to each other we need to reload the app to the place they were trying to go
        if (to.path !== from.path) reloadApp(to.fullPath)

        next()
    })

    // This event will fire everytime the window/tab is activated or deactivated. We use it to check if the window is visable.
    // That means that when the window/tab was not active we can then force reload the app if we need them to
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event#examples
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reloadApp(app.router.currentRoute.fullPath)
    })
}
